import React from 'react';
import { Box, Typography } from '@material-ui/core';
import './public-user.style.css';

export const PublicMeetings = () => {
  return (
    <Box boxShadow={1} className='public-user-container'>
      <Box p={3}>
        <Box mb={2}>
          <Typography className='public-user-header' variant='h2'>
            Public meetings
          </Typography>
        </Box>
        <Box baxShadow={5} p={2} display='flex' justifyContent='center'>
          <Typography>In coming</Typography>
        </Box>
      </Box>
    </Box>
  );
};
